import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M1.733 3.4A1.333 1.333 0 0 1 3.4 1.732l10.539 3.243c1.149.354 1.28 1.929.204 2.467L9.676 9.676l-2.233 4.467c-.539 1.076-2.113.945-2.467-.204L1.733 3.399Zm1.274-.392 3.244 10.539L8.484 9.08c.129-.258.338-.467.596-.596l4.466-2.234L3.007 3.008Z"
    }, null, -1)
  ]))]))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "geo-send"}) } }